import React, { useCallback } from "react";
import { Modal, ModalBody } from "reactstrap";
import { useDropzone } from "react-dropzone";

const UploadModal = ({ isOpen, toggle, onUpload }) => {
    const onDrop = useCallback((acceptedFiles) => {
        onUpload(acceptedFiles);
    }, [onUpload]);

    const { getRootProps, getInputProps } = useDropzone({ onDrop });

    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalBody>
                <div {...getRootProps()} style={{ border: "2px dashed #999", padding: 30, textAlign: "center" }}>
                    <input {...getInputProps()} />
                    <p>Drag & drop files here, or click to select</p>
                </div>
            </ModalBody>
        </Modal>
    );
};

export default UploadModal;
